import { render, staticRenderFns } from "./operations2.vue?vue&type=template&id=13a85944&scoped=true&"
import script from "./operations2.vue?vue&type=script&lang=js&"
export * from "./operations2.vue?vue&type=script&lang=js&"
import style0 from "./operations2.vue?vue&type=style&index=0&id=13a85944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a85944",
  null
  
)

export default component.exports